import configureAxios from 'configure/axios';

const axios = configureAxios();

export const findProduct = id => axios.get(`/products/${id}/`);